import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class SalesHistory {
    constructor(doc)
    {
        this.label = null;
        this.ownershipTransferAmountNotAvailableReasonType = null;
        this.ownershipTransferAmountNotAvailableReasonTypeOtherDescription = null;
        this.ownershipTransferDate = null;
        this.ownershipTransferTransactionAmount = null;
        this.ownershipTransferTransactionType = null;
        this.saleType = null;
        this.saleTypeOtherDescription = null;

        this.label = x.getStringAttribute(doc,"xlink:label");
        this.ownershipTransferAmountNotAvailableReasonType = x.getStringElement(doc, "./ns:OwnershipTransferAmountNotAvailableReasonType");
        this.ownershipTransferAmountNotAvailableReasonTypeOtherDescription = x.getStringElement(doc, "./ns:OwnershipTransferAmountNotAvailableReasonTypeOtherDescription");
        this.ownershipTransferDate = x.getMISMODateElement(doc, "./ns:OwnershipTransferDate");
        this.ownershipTransferTransactionAmount  = x.getMISMOAmountElement(doc, "./ns:OwnershipTransferTransactionAmount");
        this.ownershipTransferTransactionType = x.getStringElement(doc, "./ns:OwnershipTransferTransactionType");
        this.saleType = x.getStringElement(doc, "./ns:SaleType");
        this.saleTypeOtherDescription = x.getStringElement(doc, "./ns:SaleTypeOtherDescription");
   }

    GetOwnershipTransferType() {
        return h.descriptionOrOther(this.ownershipTransferTransactionType, this.ownershipTransferTransactionTypeOtherDescription);
    }

    GetSaleType() {
        return h.descriptionOrOther(this.saleType, this.saleTypeOtherDescription);
    }

    GetAmountNotAvailableReason() {
        return h.descriptionOrOther(this.ownershipTransferAmountNotAvailableReasonType, this.ownershipTransferAmountNotAvailableReasonTypeOtherDescription);
    }

}

export class Sales {
    constructor(doc) {
        this.salesContracts = [];
        this.salesHistories = [];
        var nodes;

        nodes = x.selectNodes(doc, "./ns:SALES_CONTRACTS/ns:SALES_CONTRACT");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.salesContracts.push(new SalesContract(xn));
            });
        }
        nodes = x.selectNodes(doc, "./ns:SALES_HISTORIES/ns:SALES_HISTORY");
        if (nodes.length > 0)
        {
            nodes.forEach((xn) => {
                this.salesHistories.push(new SalesHistory(xn));
            });
        }
    }

    GetAllRightsAppraisedIndicator() {
        if (!this.salesContracts || this.salesContracts.length === 0) return false;
        return (this.salesContracts[0].salesContractDetail.allPropertyRightsAppraisedIndicator ?? false);
    }

    GetConcessionIndicator() {
        if (!this.salesContracts || this.salesContracts.length === 0) return false;
        return (this.salesContracts[0].salesContractDetail.salesConcessionIndicator ?? false);
    }

    GetConcessionKnown() {
        if (!this.salesContracts || this.salesContracts.length === 0) return false;
        return (this.salesContracts[0].salesContractDetail.salesConcessionAmountKnownIndicator ?? false);
    }

    GetConcessionAmount() {
        if (!this.salesContracts || this.salesContracts.length === 0) return null;
        if (this.salesContracts[0].salesContractDetail.salesConcessionAmountKnownIndicator == null) return null;
        if (!(this.salesContracts[0].salesContractDetail.salesConcessionAmountKnownIndicator ?? false)) return null;
        return this.salesContracts[0].salesContractDetail.totalSalesConcessionAmount;
    }

    GetContractReviewed() {
        if (!this.salesContracts || this.salesContracts.length === 0) return false;
        if (!this.salesContracts[0].salesContractDetail.salesContractAmount.HasValue()) return false;
        return this.salesContracts[0].salesContractDetail.salesContractReviewedIndicator ?? false;
    }

    GetContractAmount() {
        if (!this.salesContracts || this.salesContracts.length === 0) return null;
        return this.salesContracts[0].salesContractDetail.salesContractAmount;
    }

    GetContractDate() {
        if (!this.salesContracts || this.salesContracts.length === 0) return null;
        return this.salesContracts[0].salesContractDetail.salesContractDate;
    }

    GetContractSaleDate() {
        if (!this.salesContracts || this.salesContracts.length === 0) return null;
        return this.salesContracts[0].salesContractDetail.salesContractDate;
    }

    GetHistoryTransferDate() {
        if (this.salesHistories.length === 0) return null;
        let histDate = null;
        for (const history of this.salesHistories) {
            if (history.ownershipTransferTransactionType === "Sale") {
                if ( histDate !== null) {
                    if (history.ownershipTransferDate.IsLaterThan(histDate)) {
                        histDate = history.ownershipTransferDate;
                    }
                }
                else {
                    histDate = history.ownershipTransferDate;
                }
            }
        }
        return histDate;
    }

    GetHistoryTransferAmount() {
        if (this.salesHistories.length === 0) return null;
        let amount = null;
        let histDate = null;
        for (const history of this.salesHistories) {
            if (history.ownershipTransferTransactionType === "Sale") {
                if ( histDate !== null) {
                    if (history.ownershipTransferDate.IsLaterThan(histDate)) {
                        amount = history.ownershipTransferTransactionAmount;
                        histDate = history.ownershipTransferDate;
                    }
                }
                else {
                    amount = history.ownershipTransferTransactionAmount;
                    histDate = history.ownershipTransferDate;
                }
            }
        }
        return amount;
    }

    GetSalesHistoryByTransferType(type) {
        if (this.salesHistories.length === 0) return null;
        for (const history of this.salesHistories) {
            if (history.ownershipTransferTransactionType === type) {
                return history;
            }
        }
        return null;
    }
}

export class SalesContractDetail {
		constructor(doc)
		{
		this.label = null
		this.allPropertyRightsAppraisedIndicator = null
		this.armsLengthIndicator = null
		this.nonArmsLengthCommentText = null
		this.personalPropertyIncludedIndicator = null
		this.salesConcessionAmountKnownIndicator = null
		this.salesConcessionIndicator = null
		this.salesConcessionsTypicalToMarketIndicator = null
		this.salesContractAmount = null;
		this.salesContractDate = null
		this.salesContractExistsIndicator = null
		this.salesContractReviewedIndicator = null
		this.saleType = null
		this.saleTypeOtherDescription = null
		this.totalSalesConcessionAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.allPropertyRightsAppraisedIndicator = x.getBooleanElement(doc, "./ns:AllPropertyRightsAppraisedIndicator");
		this.armsLengthIndicator = x.getBooleanElement(doc, "./ns:ArmsLengthIndicator");
		this.nonArmsLengthCommentText = x.getStringElement(doc, "./ns:NonArmsLengthCommentText");
		this.personalPropertyIncludedIndicator = x.getBooleanElement(doc, "./ns:PersonalPropertyIncludedIndicator");
		this.salesConcessionAmountKnownIndicator = x.getBooleanElement(doc, "./ns:SalesConcessionAmountKnownIndicator");
		this.salesConcessionIndicator = x.getBooleanElement(doc, "./ns:SalesConcessionIndicator");
		this.salesConcessionsTypicalToMarketIndicator = x.getBooleanElement(doc, "./ns:SalesConcessionsTypicalToMarketIndicator");
		this.salesContractAmount  = x.getMISMOAmountElement(doc, "./ns:SalesContractAmount");
		this.salesContractDate = x.getMISMODateElement(doc, "./ns:SalesContractDate");
		this.salesContractExistsIndicator = x.getBooleanElement(doc, "./ns:SalesContractExistsIndicator");
		this.salesContractReviewedIndicator = x.getBooleanElement(doc, "./ns:SalesContractReviewedIndicator");
		this.saleType = x.getStringElement(doc, "./ns:SaleType");
		this.saleTypeOtherDescription = x.getStringElement(doc, "./ns:SaleTypeOtherDescription");
		this.totalSalesConcessionAmount  = x.getMISMOAmountElement(doc, "./ns:TotalSalesConcessionAmount");
	 }
}

export class SalesContract {
    constructor(doc) {
        this.label = null
        this.salesContractDetail = null
        var node;

        this.label = x.getStringAttribute(doc,"xlink:label");
        node = x.selectSingleNode(doc, "./ns:SALES_CONTRACT_DETAIL");
        if (node !== null)
            this.salesContractDetail = new SalesContractDetail(node);
    }

    GetSaleType() {
        return h.descriptionOrOther(this.salesContractDetail.saleType,this.salesContractDetail.saleTypeOtherDescription);
    }
}

